import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import "summernote/dist/summernote-bs4.css"; // Bootstrap 4 theme

import axiosInstance from "../../axiosInstance";
import Select from "react-select";
import "./CronJobForm.scss";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { useAuth } from "../../contexts/AuthContext";

const CronJobForm = ({ categoryId, onClose, scheduledCronJobId }) => {
  const { user, isLoading: isAuthLoading } = useAuth();

  const [taskName, setTaskName] = useState("");
  const [cronJobType, setCronJobType] = useState([]);
  const [selectedCronJobType, setSelectedCronJobType] = useState("");

  const [isSummernoteInitialized, setIsSummernoteInitialized] = useState(false);

  const [notificationHeader, setNotificationHeader] = useState("");
  const [notificationBody, setNotificationBody] = useState("");

  // Updated to match backend enum: FromEmailSource
  const [fromEmail, setFromEmail] = useState("RESPECTIVE_EMPLOYEE");
  const [specificEmail, setSpecificEmail] = useState("");

  // Add state for company emails
  const [companyEmails, setCompanyEmails] = useState([]);
  const [selectedCompanyEmail, setSelectedCompanyEmail] = useState("");

  // Updated to match backend enum: ToEmailSourceFrom
  const [toEmail, setToEmail] = useState("CANDIDATE");

  const [specificEmails, setSpecificEmails] = useState([]);

  // Add state for selected company emails for "To" field
  const [selectedCompanyEmailsTo, setSelectedCompanyEmailsTo] = useState([]);

  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [emp, setEmp] = useState([]);

  const [messageHeading, setMessageHeading] = useState("");

  const [when, setWhen] = useState("OnDATE");
  const [days, setDays] = useState(0);

  const [emailContent, setEmailContent] = useState("");
  const summernoteRef = useRef(null);

  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [time, setTime] = useState("");
  const [delayInMs, setDelayInMs] = useState(null);

  // Add state for specific email configs (for SPECIFIC option)
  const [specificEmailConfigs, setSpecificEmailConfigs] = useState([]);
  const [selectedSpecificEmailConfig, setSelectedSpecificEmailConfig] =
    useState("");

  const [notificationTypes, setNotificationTypes] = useState([]);
  const [selectedNotificationTypes, setSelectedNotificationTypes] = useState(
    [],
  );

  const [placeholders, setPlaceholders] = useState([]);

  // Holds the raw fetched record for the cron job being edited so that
  // from-email matching can be (re)run once companyEmails / specificEmailConfigs
  // have actually finished loading (see matching useEffect below).
  const [savedCronJobData, setSavedCronJobData] = useState(null);

  const [loading, setLoading] = useState(false);

  const notificationHeaderRef = useRef(null);
  const notificationBodyRef = useRef(null);
  const messageHeadingRef = useRef(null);
  const [activeField, setActiveField] = useState(null);

  const FROM_EMAIL_OPTIONS = [
    { value: "SPECIFIC", label: "Specific" },
    { value: "COMPANY", label: "Company" },
    { value: "RESPECTIVE_EMPLOYEE", label: "Respective Employee" },
    { value: "RESPECTIVE_ACCOUNTANT", label: "Respective Accountant" },
    { value: "RESPECTIVE_MANAGER", label: "Respective Manager" },
    { value: "RESPECTIVE_HR", label: "Respective Hr" },
  ];

  const TO_EMAIL_OPTIONS = [
    { value: "CANDIDATE", label: "Candidate" },
    { value: "DEPARTMENT", label: "Department" },
    { value: "BRANCH", label: "Branch" },
    { value: "ROLE", label: "Role" },
    { value: "ALLEMP", label: "All Employees" },
    { value: "SPECIFIC_EMPLOYEES", label: "Specific Employees" },
    { value: "COMPANY", label: "Company" },
    { value: "RESPECTIVE_EMPLOYEE", label: "Respective Employee" },
    { value: "RESPECTIVE_MANAGER", label: "Respective Manager" },
    { value: "RESPECTIVE_HR", label: "Respective Hr" },
    { value: "RESPECTIVE_ACCOUNTANT", label: "Respective Accountant" },
  ];

  const mapDisplayToEnumValue = (displayValue, optionsArray) => {
    const option = optionsArray.find((opt) => opt.label === displayValue);
    return option ? option.value : displayValue;
  };

  // Initialize Summernote
  useEffect(() => {
    if (summernoteRef.current && !isSummernoteInitialized) {
      $(summernoteRef.current).summernote({
        height: 300,
        width: "100%",
        placeholder: "Enter email content here...",
        theme: "bs4",
        toolbar: [
          ["style", ["style"]],
          [
            "font",
            [
              "bold",
              "underline",
              "italic",
              "strikethrough",
              "superscript",
              "subscript",
              "clear",
            ],
          ],
          ["fontname", ["fontname"]],
          ["fontsize", ["fontsize"]],
          ["color", ["forecolor", "backcolor"]],
          ["para", ["ul", "ol", "paragraph", "height"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video", "hr"]],
          ["view", ["fullscreen", "codeview", "help"]],
          ["misc", ["undo", "redo"]],
        ],
        fontNames: [
          "Arial",
          "Arial Black",
          "Comic Sans MS",
          "Courier New",
          "Helvetica",
          "Impact",
          "Tahoma",
          "Times New Roman",
          "Verdana",
        ],
        fontSizes: [
          "8",
          "9",
          "10",
          "11",
          "12",
          "14",
          "16",
          "18",
          "20",
          "24",
          "36",
          "48",
        ],
        callbacks: {
          onChange: (contents) => {
            setEmailContent(contents);
          },
          onFocus: () => {
            setActiveField("emailBody");
          },
          onBlur: () => {
            // Don't immediately clear activeField, give some delay
            setTimeout(() => {
              setActiveField(null);
            }, 100);
          },
          onInit: () => {
            // Set initial content after initialization if available
            if (emailContent) {
              setTimeout(() => {
                $(summernoteRef.current).summernote("code", emailContent);
              }, 100);
            }
          },
        },
      });
      setIsSummernoteInitialized(true);
    }

    // Cleanup function
    return () => {
      if (summernoteRef.current && isSummernoteInitialized) {
        try {
          $(summernoteRef.current).summernote("destroy");
          setIsSummernoteInitialized(false);
        } catch (error) {
          console.warn("Error destroying Summernote:", error);
        }
      }
    };
  }, [isSummernoteInitialized]);

  // Update Summernote content when emailContent changes programmatically
  useEffect(() => {
    if (isSummernoteInitialized && summernoteRef.current && emailContent) {
      const currentContent = $(summernoteRef.current).summernote("code");
      // Only update if content is different to avoid cursor issues
      if (currentContent !== emailContent) {
        // Store cursor position if Summernote is focused
        const isFocused = $(summernoteRef.current)
          .next(".note-editor")
          .find(".note-editable")
          .is(":focus");

        setTimeout(() => {
          $(summernoteRef.current).summernote("code", emailContent);

          // Restore focus if it was previously focused
          if (isFocused) {
            $(summernoteRef.current).summernote("focus");
          }
        }, 100);
      }
    }
  }, [emailContent, isSummernoteInitialized]);

  useEffect(() => {
    if (scheduledCronJobId) {
      fetchCronJobDetails(scheduledCronJobId);
    }
  }, [scheduledCronJobId]);

  // Company emails are needed for both the "From: Company" and
  // "To: Company" pickers regardless of what this record's source is, so
  // fetch them eagerly. Specific email configs (admin/hr `/email-config`)
  // are NOT fetched here — that call is only relevant when "Specific" is
  // actually the from-email source, so it's triggered by the effect below
  // instead of firing on every single edit/create regardless of source.
  useEffect(() => {
    fetchCompanyEmails();
  }, []);

  // Fetch specific email configs only when "Specific" is actually the
  // selected from-email source — either because the user picked it while
  // creating a new automation, or because it's set to "SPECIFIC" once the
  // edited record's saved source is known (see fetchCronJobDetails). This
  // avoids hitting /email-config for records that use Company/Respective/etc.
  useEffect(() => {
    if (fromEmail === "SPECIFIC" && specificEmailConfigs.length === 0) {
      fetchSpecificEmailConfigs();
    }
  }, [fromEmail, specificEmailConfigs.length]);

  // Modified to be reusable for both From and To email fields
  const fetchCompanyEmails = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/company/email-config/All`,
      );

      setCompanyEmails(data.data || []);
      if (data.data && data.data.length > 0 && fromEmail === "COMPANY") {
        setSelectedCompanyEmail(data.data[0].emailConfigid);
      }
    } catch (error) {
      console.error("Error fetching company emails:", error);
    } finally {
      setLoading(false);
    }
  };

  // New function to fetch specific email configs based on user authorities
  const fetchSpecificEmailConfigs = async () => {
    setLoading(true);
    try {
      const userAuthorities = user.authorities || [];

      let apiEndpoint = "";
      if (userAuthorities.includes("ROLE_ADMIN")) {
        apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/email-config`;
      } else if (userAuthorities.includes("ROLE_HR")) {
        apiEndpoint = `${process.env.REACT_APP_API_HR_URL}/email-config`;
      } else {
        console.warn(
          "User doesn't have required authorities to fetch email configs",
        );
        setSpecificEmailConfigs([]); // Set empty array if no authority
        return;
      }

      const { data } = await axiosInstance.get(apiEndpoint);
      console.log("Specific Email Configs Response:", data); // Debug log

      // Handle different response structures
      if (Array.isArray(data)) {
        setSpecificEmailConfigs(data);
      } else if (data && Array.isArray(data.data)) {
        setSpecificEmailConfigs(data.data);
      } else if (data && data.data && !Array.isArray(data.data)) {
        // If single object returned, wrap in array
        setSpecificEmailConfigs([data.data]);
      } else {
        console.warn("Unexpected API response structure:", data);
        setSpecificEmailConfigs([]);
      }
    } catch (error) {
      console.error("Error fetching specific email configs:", error);
      setSpecificEmailConfigs([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const fetchCronJobDetails = async (id) => {
    setLoading(true);
    try {
      const userAuthorities = user.authorities || [];

      let apiEndpoint = userAuthorities.includes("ROLE_ADMIN")
        ? `${process.env.REACT_APP_API_BASE_URL}/scheduled-cron-jobs/${id}`
        : userAuthorities.includes("ROLE_HR")
          ? `${process.env.REACT_APP_API_HR_URL}/scheduled-cron-jobs/${id}`
          : null;

      if (!apiEndpoint) {
        console.error("Unauthorized: Unable to fetch cron job details.");
        return;
      }

      const { data } = await axiosInstance.get(apiEndpoint);
      console.log("Fetched cron job details:", data);

      if (data?.data) {
        setTaskName(data.data.taskName || "");
        setSelectedCronJobType(data.data.cronJobTypeId || "");

        // Convert notification types to react-select format
        if (
          data.data.notificationTypes &&
          data.data.notificationTypes.length > 0
        ) {
          setSelectedNotificationTypes(
            data.data.notificationTypes.map((type) => ({
              value: type.notificationTypeId,
              label: type.notificationType || type.type,
            })),
          );
        }

        const fromEmailValue =
          mapDisplayToEnumValue(
            data.data.fromEmailSource,
            FROM_EMAIL_OPTIONS,
          ) || "RESPECTIVE_EMPLOYEE";
        const toEmailValue =
          mapDisplayToEnumValue(
            data.data.toEmailSourceFrom,
            TO_EMAIL_OPTIONS,
          ) || "CANDIDATE";
        setFromEmail(fromEmailValue);
        setToEmail(toEmailValue);

        // Parse the cron expression to extract time - FIXED VERSION
        if (data.data.cronJobExpression) {
          const cronParts = data.data.cronJobExpression.split(" ");
          // Handle format: "0 minutes hours * * *"
          if (cronParts.length >= 3) {
            const minutes = cronParts[1] || "0";
            const hours = cronParts[2] || "0";

            // Format as HH:MM for time input
            const formattedTime = `${hours
              .toString()
              .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
            setTime(formattedTime);
          }
        }

        // FIX: Handle triggerDate with proper mapping and validation
        const triggerDateValue = data.data.triggerDate;
        console.log("API triggerDate value:", triggerDateValue);

        // Map API values to component values if needed
        let mappedTriggerDate = "OnDATE"; // default
        if (triggerDateValue) {
          switch (triggerDateValue.toUpperCase()) {
            case "ONDATE":
            case "ON_DATE":
              mappedTriggerDate = "OnDATE";
              break;
            case "DATEBEFORE":
            case "DATE_BEFORE":
            case "BEFORE":
              mappedTriggerDate = "DateBEFORE";
              break;
            case "DATEAFTER":
            case "DATE_AFTER":
            case "AFTER":
              mappedTriggerDate = "DateAFTER";
              break;
            default:
              mappedTriggerDate = triggerDateValue; // Use as-is if it matches exactly
          }
        }

        console.log("Setting when to:", mappedTriggerDate);
        setWhen(mappedTriggerDate);

        // Set days value
        const daysValue = data.data.days || 0;
        console.log("Setting days to:", daysValue);
        setDays(daysValue);

        // Handle template data - FIXED VERSION
        const template = data.data.cronJobTemplate || {};
        if (template.body) {
          setEmailContent(template.body);

          // Also set it directly in Summernote if it's already initialized
          if (isSummernoteInitialized && summernoteRef.current) {
            setTimeout(() => {
              $(summernoteRef.current).summernote("code", template.body);
            }, 200);
          }
        }

        setMessageHeading(template.subject || "");
        setNotificationHeader(template.notificationHeading || "");
        setNotificationBody(template.notificationMessage || "");

        // NOTE: Matching the saved fromEmail address to a companyEmails /
        // specificEmailConfigs entry is NOT done here. companyEmails and
        // specificEmailConfigs are fetched in a separate useEffect (on
        // mount) and there is no guarantee they've finished loading by the
        // time this response comes back. Doing the lookup here against a
        // (likely still-empty) array is why the "From Email" selection
        // wasn't auto-selecting on edit. Instead we stash the raw record
        // and let the dedicated matching useEffect below run once the
        // lookup lists are actually populated.
        setSavedCronJobData(data.data);

        if (
          mapDisplayToEnumValue(
            data.data.fromEmailSource,
            FROM_EMAIL_OPTIONS,
          ) === "SPECIFIC" &&
          data.data.fromEmail &&
          !specificEmailConfigs.some(
            (config) => config.fromEmail === data.data.fromEmail,
          )
        ) {
          // Fallback so the field isn't blank even before configs load;
          // the matching effect will overwrite this with the config id
          // once specificEmailConfigs is available, if a match exists.
          setSpecificEmail(data.data.fromEmail);
        }

        // Handle notification target sources - Rest remains the same
        if (data.data.notifyToSource && data.data.notifyToSource.length > 0) {
          // Process departments
          const depts = data.data.notifyToSource
            .filter((item) => item.type === "DEPARTMENT")
            .map((item) => ({ value: item.sourceId, label: item.name }));
          if (depts.length > 0) {
            setSelectedDepartments(depts);
            if (toEmail !== "DEPARTMENT") setToEmail("DEPARTMENT");
          }

          // Process branches
          const branchList = data.data.notifyToSource
            .filter((item) => item.type === "BRANCH")
            .map((item) => ({ value: item.sourceId, label: item.name }));
          if (branchList.length > 0) {
            setSelectedBranches(branchList);
            if (toEmail !== "BRANCH") setToEmail("BRANCH");
          }

          // Process roles
          const roleList = data.data.notifyToSource
            .filter((item) => item.type === "ROLE")
            .map((item) => ({ value: item.sourceId, label: item.name }));
          if (roleList.length > 0) {
            setSelectedRoles(roleList);
            if (toEmail !== "ROLE") setToEmail("ROLE");
          }

          // Process employees
          const empList = data.data.notifyToSource
            .filter((item) => item.type === "EMPLOYEE")
            .map((item) => ({
              value: item.sourceId,
              label: item.name || `Employee ${item.sourceId}`,
            }));
          if (empList.length > 0) {
            setSelectedEmployees(empList);
            if (toEmail !== "SPECIFIC_EMPLOYEES")
              setToEmail("SPECIFIC_EMPLOYEES");
          }

          // Handle company emails in To field if present
          const companyEmailsInSource = data.data.notifyToSource
            .filter((item) => item.type === "COMPANY")
            .map((item) => ({
              value: item.sourceId,
              label:
                companyEmails.find(
                  (email) => email.emailConfigid === item.sourceId,
                )?.fromEmail || `Company Email ${item.sourceId}`,
            }));

          if (companyEmailsInSource.length > 0) {
            setSelectedCompanyEmailsTo(companyEmailsInSource);
            if (toEmail !== "COMPANY") setToEmail("COMPANY");
          }
        }

        // Handle specific emails
        if (data.data.notifyToEmails && data.data.notifyToEmails.length > 0) {
          setSpecificEmails(
            data.data.notifyToEmails.map((email) => email.email) || [],
          );
        }
      }
    } catch (error) {
      console.error("Error fetching cron job details:", error);
    } finally {
      setLoading(false);
    }
  };

  // Runs whenever the saved record OR the lookup lists change, so it
  // reliably matches the saved "fromEmail" address to a company/specific
  // email config regardless of which one finishes loading first.
  useEffect(() => {
    if (!savedCronJobData) return;

    // The API returns fromEmailSource as a display label ("Company",
    // "Specific"), not the enum used by FROM_EMAIL_OPTIONS ("COMPANY",
    // "SPECIFIC"). The "Email From" select works because it's fed through
    // mapDisplayToEnumValue already; we need to do the same mapping here
    // rather than comparing the raw label, or this match never fires.
    const mappedSource = mapDisplayToEnumValue(
      savedCronJobData.fromEmailSource,
      FROM_EMAIL_OPTIONS,
    );

    if (
      mappedSource === "COMPANY" &&
      savedCronJobData.fromEmail &&
      companyEmails.length > 0
    ) {
      const matchingConfig = companyEmails.find(
        (config) => config.fromEmail === savedCronJobData.fromEmail,
      );
      if (matchingConfig) {
        setSelectedCompanyEmail(matchingConfig.emailConfigid.toString());
      }
    }

    if (
      mappedSource === "SPECIFIC" &&
      savedCronJobData.fromEmail &&
      specificEmailConfigs.length > 0
    ) {
      const matchingConfig = specificEmailConfigs.find(
        (config) => config.fromEmail === savedCronJobData.fromEmail,
      );
      if (matchingConfig) {
        setSelectedSpecificEmailConfig(matchingConfig.emailConfigid.toString());
      }
    }
  }, [savedCronJobData, companyEmails, specificEmailConfigs]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, branchRes, roleRes, empRes] = await Promise.all([
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/departments/all`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/branches`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/roles/enabled`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/employees/All`,
          ),
        ]);

        setDepartments(deptRes.data.data || []);
        setBranches(branchRes.data.data || []);
        setRoles(roleRes.data.data || []);
        setEmp(empRes.data.data || []);
      } catch (error) {
        console.error("Error fetching dropdown data", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchCronJobTypes = async () => {
      if (!categoryId) return;

      const authorities = user.authorities || [];

      let endpoint = "";
      if (authorities.includes("ROLE_HR")) {
        endpoint = `${process.env.REACT_APP_API_EMPLOYEE_URL}/automation-category/${categoryId}/cronjob-types`;
      } else {
        endpoint = `${process.env.REACT_APP_API_EMPLOYEE_URL}/automation-category/${categoryId}/cronjob-types`;
      }

      try {
        const response = await axiosInstance.get(endpoint);
        setCronJobType(response.data.data || []);
      } catch (error) {
        console.error("Error fetching cron job types", error);
      }
    };

    fetchCronJobTypes();
  }, [categoryId]);

  // Function to detect if content contains HTML
  const containsHTML = (content) => {
    if (!content) return false;

    // Remove whitespace and check if it contains HTML tags
    const trimmedContent = content.trim();

    // Check for common HTML tags
    const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;

    // Check for HTML entities
    const htmlEntityRegex = /&[a-zA-Z0-9#]+;/;

    // Check for Summernote's default HTML structure (even empty content has some HTML)
    const hasSignificantHTML =
      htmlTagRegex.test(trimmedContent) &&
      !trimmedContent.match(/^<p><br><\/p>$|^<p><\/p>$|^<br>$/);

    return hasSignificantHTML || htmlEntityRegex.test(trimmedContent);
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!time) {
      console.error("Time is required");
      return;
    }

    // Get the current content from Summernote before submitting
    if (isSummernoteInitialized && summernoteRef.current) {
      const currentContent = $(summernoteRef.current).summernote("code");
      setEmailContent(currentContent);
    }

    const userAuthorities = user.authorities || [];

    let apiEndpoint = userAuthorities.includes("ROLE_ADMIN")
      ? `${process.env.REACT_APP_API_BASE_URL}/scheduled-cron-jobs`
      : userAuthorities.includes("ROLE_HR")
        ? `${process.env.REACT_APP_API_HR_URL}/scheduled-cron-jobs`
        : null;

    if (!apiEndpoint) {
      console.error("Unauthorized: Only Admins or HR can schedule a cron job.");
      return;
    }

    // Convert time to cron expression (assumes HH:mm format)
    const [hour, minute] = time.split(":");
    const cronExpression = `0 ${minute} ${hour} * * *`; // Adding '0' for seconds field

    // Determine the fromEmail value based on selection
    let finalFromEmail = "";
    // With this:
    if (fromEmail === "SPECIFIC") {
      // Find the selected specific email configuration and extract the email address
      const selectedConfig = specificEmailConfigs.find(
        (config) =>
          config.emailConfigid.toString() ===
          selectedSpecificEmailConfig.toString(),
      );
      finalFromEmail = selectedConfig
        ? selectedConfig.fromEmail
        : specificEmail;
    } else if (fromEmail === "COMPANY") {
      // Find the selected company email configuration and extract the email address
      const selectedConfig = companyEmails.find(
        (email) =>
          email.emailConfigid.toString() === selectedCompanyEmail.toString(),
      );
      finalFromEmail = selectedConfig ? selectedConfig.fromEmail : "";
    } else {
      finalFromEmail = "";
    }

    // Get the final email content from Summernote
    const finalEmailContent =
      isSummernoteInitialized && summernoteRef.current
        ? $(summernoteRef.current).summernote("code")
        : emailContent;

    // Detect if the email content contains HTML
    const isHtmlBody = containsHTML(finalEmailContent);

    // Prepare cron job data payload
    const cronJobData = {
      scheduledCronJobId: scheduledCronJobId || 0, // Use 0 if creating new
      cronJobTypeId: selectedCronJobType,
      taskName,
      notificationTypeIds: selectedNotificationTypes.map((type) =>
        parseInt(type.value),
      ),
      toEmailSourceFrom: toEmail,
      fromEmailSource: fromEmail,
      fromEmail: finalFromEmail,
      cronJobExpression: cronExpression,
      triggerDate: when,
      days: when !== "OnDate" ? parseInt(days) : 0,
      status: "ENABLED",
      employeeId: 0,
      companyId: parseInt(process.env.REACT_APP_COMPANY_ID),
      cronJobTemplate: {
        templateId: 0,
        templateName: taskName,
        subject: messageHeading,
        body: finalEmailContent,
        htmlBody: isHtmlBody, // Auto-detect HTML content
        notificationHeading: notificationHeader,
        notificationMessage: notificationBody,
      },
      notifyToSource: [
        ...selectedDepartments.map((d) => ({
          sourceId: d.value,
          employeeId: 0,
          type: "DEPARTMENT",
        })),
        ...selectedBranches.map((b) => ({
          sourceId: b.value,
          employeeId: 0,
          type: "BRANCH",
        })),
        ...selectedRoles.map((r) => ({
          sourceId: r.value,
          employeeId: 0,
          type: "ROLE",
        })),
        ...selectedEmployees.map((e) => ({
          sourceId: e.value,
          employeeId: e.value,
          type: "EMPLOYEE",
        })),
        ...selectedCompanyEmailsTo.map((email) => ({
          sourceId: email.value,
          employeeId: 0,
          type: "COMPANY",
        })),
      ],
      notifyToEmails: specificEmails.map((email) => ({ email, employeeId: 0 })),
    };

    console.log(cronJobData);

    try {
      const isUpdating = scheduledCronJobId && parseInt(scheduledCronJobId) > 0;
      const url = `${apiEndpoint}${isUpdating ? "" : ""}`;
      console.log(url);

      const response = isUpdating
        ? await axiosInstance.put(url, cronJobData) // PUT for update
        : await axiosInstance.post(url, cronJobData); // POST for create

      console.log(
        `Cron Job ${isUpdating ? "Updated" : "Created"} Successfully`,
        response.data,
      );

      onClose(); // Close the form after successful submission
    } catch (error) {
      console.error(
        "Error scheduling cron job:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // Fetch notification types based on role
  useEffect(() => {
    const fetchNotificationTypes = async () => {
      const authorities = user.authorities || [];

      let endpoint = "";
      if (authorities.includes("ROLE_HR")) {
        endpoint = `${process.env.REACT_APP_API_HR_URL}/notification-types/all`;
      } else if (authorities.includes("ROLE_ADMIN")) {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/notification-types/all`;
      } else {
        console.warn("No matching role for notification types");
        return;
      }

      try {
        const response = await axiosInstance.get(endpoint);
        setNotificationTypes(response.data.data || []);
      } catch (error) {
        console.error("Error fetching notification types", error);
      }
    };

    fetchNotificationTypes();
  }, []);

  useEffect(() => {
    const fetchPlaceholders = async () => {
      if (!selectedCronJobType) return;

      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/placeholders/cronjob/${selectedCronJobType}`,
        );

        setPlaceholders(response.data.data || []);
      } catch (error) {
        console.error("Error fetching placeholders", error);
      }
    };

    fetchPlaceholders();
  }, [selectedCronJobType]);

  // Handle time input change
  const handleTimeChange = (e) => {
    const newTime = e.target.value;
    setTime(newTime);

    if (newTime) {
      const [hour, minute] = newTime.split(":");
      const cronExpression = `0 ${minute} ${hour} * * *`; // Adding '0' for seconds
      console.log("Generated Cron Expression:", cronExpression);
    }
  };

  // Handle From Email change
  const handleFromEmailChange = (e) => {
    const value = e.target.value;
    setFromEmail(value);

    // Reset related values
    if (value !== "SPECIFIC") {
      setSpecificEmail("");
      setSelectedSpecificEmailConfig("");
    }
    if (value !== "COMPANY") {
      setSelectedCompanyEmail("");
    }
  };

  // Handle To Email change
  const handleToEmailChange = (e) => {
    const value = e.target.value;
    setToEmail(value);

    // Reset related values based on selection
    if (value !== "DEPARTMENT") {
      setSelectedDepartments([]);
    }
    if (value !== "BRANCH") {
      setSelectedBranches([]);
    }
    if (value !== "ROLE") {
      setSelectedRoles([]);
    }
    if (value !== "SPECIFIC_EMPLOYEES") {
      setSelectedEmployees([]);
    }
    if (value !== "COMPANY") {
      setSelectedCompanyEmailsTo([]);
    }
  };

  const insertPlaceholderInActiveField = (placeholderText) => {
    // Always check Summernote first since it's the most complex field
    if (isSummernoteInitialized && summernoteRef.current) {
      // Check if activeField is emailBody OR if Summernote has focus OR if no other field has focus
      const summernoteElement = $(summernoteRef.current).next(".note-editor");
      const summernoteHasFocus =
        summernoteElement.find(".note-editable").is(":focus") ||
        summernoteElement.find(".note-editable").hasClass("focus");

      if (
        activeField === "emailBody" ||
        summernoteHasFocus ||
        !document.activeElement ||
        (document.activeElement !== notificationHeaderRef.current &&
          document.activeElement !== notificationBodyRef.current &&
          document.activeElement !== messageHeadingRef.current)
      ) {
        // Focus and insert into Summernote
        $(summernoteRef.current).summernote("focus");
        setTimeout(() => {
          $(summernoteRef.current).summernote("insertText", placeholderText);
        }, 50);
        return;
      }
    }

    // Handle other input fields
    let targetRef = null;
    let setValue = null;
    let currentValue = "";

    switch (activeField) {
      case "notificationHeader":
        targetRef = notificationHeaderRef;
        setValue = setNotificationHeader;
        currentValue = notificationHeader;
        break;
      case "notificationBody":
        targetRef = notificationBodyRef;
        setValue = setNotificationBody;
        currentValue = notificationBody;
        break;
      case "messageHeading":
        targetRef = messageHeadingRef;
        setValue = setMessageHeading;
        currentValue = messageHeading;
        break;
      default:
        // Check which field currently has focus
        if (document.activeElement === notificationHeaderRef.current) {
          targetRef = notificationHeaderRef;
          setValue = setNotificationHeader;
          currentValue = notificationHeader;
        } else if (document.activeElement === notificationBodyRef.current) {
          targetRef = notificationBodyRef;
          setValue = setNotificationBody;
          currentValue = notificationBody;
        } else if (document.activeElement === messageHeadingRef.current) {
          targetRef = messageHeadingRef;
          setValue = setMessageHeading;
          currentValue = messageHeading;
        } else {
          // If no field has focus, default to email body
          if (isSummernoteInitialized && summernoteRef.current) {
            $(summernoteRef.current).summernote("focus");
            setTimeout(() => {
              $(summernoteRef.current).summernote(
                "insertText",
                placeholderText,
              );
            }, 50);
          }
          return;
        }
        break;
    }

    if (targetRef.current && setValue) {
      const element = targetRef.current;
      const start = element.selectionStart || 0;
      const end = element.selectionEnd || 0;
      const newValue =
        currentValue.substring(0, start) +
        placeholderText +
        currentValue.substring(end);
      setValue(newValue);

      setTimeout(() => {
        element.selectionStart = element.selectionEnd =
          start + placeholderText.length;
        element.focus();
      }, 0);
    }
  };

  return (
    <div className="template-content">
      <h1 className="display6">Automations</h1>
      <div className="eventform-header">
        <button type="button" className="back-button" onClick={onClose}>
          ← Back
        </button>
      </div>
      {loading && <LoadingScreen />}

      <form className="template-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label>Automation Name</label>
            <input
              type="text"
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Automation Type </label>
            <select
              value={selectedCronJobType}
              onChange={(e) => {
                const selectedId = Number(e.target.value);
                console.log("Selected Cron Job Type ID:", selectedId);
                setSelectedCronJobType(selectedId);
              }}
              required
            >
              <option value="" disabled>
                Select Automation Type
              </option>
              {cronJobType.map((type) => (
                <option key={type.cronJobId} value={type.cronJobId}>
                  {type.eventName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Notification Types</label>
            <Select
              isMulti
              options={notificationTypes.map((type) => ({
                value: type.notificationTypeId,
                label: type.type,
              }))}
              value={selectedNotificationTypes}
              onChange={(selected) => setSelectedNotificationTypes(selected)}
              placeholder="Select notification types..."
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

          <div className="form-group">
            <label>Email From</label>
            <select value={fromEmail} onChange={handleFromEmailChange}>
              {FROM_EMAIL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {fromEmail === "SPECIFIC" && (
            <div className="form-group">
              <label>Specific Email Config *</label>
              <select
                value={selectedSpecificEmailConfig}
                onChange={(e) => setSelectedSpecificEmailConfig(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Email Configuration
                </option>
                {Array.isArray(specificEmailConfigs) &&
                  specificEmailConfigs.map((config) => (
                    <option
                      key={config.emailConfigid}
                      value={config.emailConfigid}
                    >
                      {config.fromEmail} ({config.fullName || "Email Config"})
                    </option>
                  ))}
              </select>
            </div>
          )}

          {fromEmail === "COMPANY" && (
            <div className="form-group">
              <label>Company Email *</label>
              <select
                value={selectedCompanyEmail}
                onChange={(e) => setSelectedCompanyEmail(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Company Email
                </option>
                {companyEmails.map((email) => (
                  <option key={email.emailConfigid} value={email.emailConfigid}>
                    {email.fromEmail} ({email.fullName || "Company Email"})
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Emails To</label>
            <select value={toEmail} onChange={handleToEmailChange}>
              {TO_EMAIL_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {toEmail === "DEPARTMENT" && (
            <div className="form-group">
              <label>Select Department *</label>
              <Select
                isMulti
                options={departments.map((dept) => ({
                  value: dept.departmentId,
                  label: dept.departmentName,
                }))}
                value={selectedDepartments}
                onChange={(selected) => setSelectedDepartments(selected)}
              />
            </div>
          )}
          {toEmail === "BRANCH" && (
            <div className="form-group">
              <label>Select Branch *</label>
              <Select
                isMulti
                options={branches.map((branch) => ({
                  value: branch.branchId,
                  label: branch.branchName,
                }))}
                value={selectedBranches}
                onChange={(selected) => setSelectedBranches(selected)}
              />
            </div>
          )}
          {toEmail === "ROLE" && (
            <div className="form-group">
              <label>Select Role *</label>
              <Select
                isMulti
                options={roles.map((role) => ({
                  value: role.roleId,
                  label: role.roleName,
                }))}
                value={selectedRoles}
                onChange={(selected) => setSelectedRoles(selected)}
              />
            </div>
          )}
          {toEmail === "SPECIFIC_EMPLOYEES" && (
            <div className="form-group">
              <label>Select Employees *</label>
              <Select
                isMulti
                options={emp.map((emp) => ({
                  value: emp.empId,
                  label: `${emp.firstName} ${emp.lastName} (${emp.email})`,
                }))}
                value={selectedEmployees}
                onChange={(selected) => setSelectedEmployees(selected)}
              />
            </div>
          )}
          {toEmail === "COMPANY" && (
            <div className="form-group">
              <label>Select Company Emails *</label>
              <Select
                isMulti
                options={companyEmails.map((email) => ({
                  value: email.emailConfigid,
                  label: `${email.fromEmail} (${
                    email.fullName || "Company Email"
                  })`,
                }))}
                value={selectedCompanyEmailsTo}
                onChange={(selected) => setSelectedCompanyEmailsTo(selected)}
                placeholder="Select company emails..."
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
        </div>

        <div className="form-with-placeholders">
          <div className="form-containter">
            <div className="form-group">
              <label>In App Notification Header</label>
              <input
                ref={notificationHeaderRef}
                type="text"
                value={notificationHeader}
                onChange={(e) => setNotificationHeader(e.target.value)}
                onFocus={() => setActiveField("notificationHeader")}
              />
            </div>

            <label>In App Notification Content</label>
            <textarea
              ref={notificationBodyRef}
              value={notificationBody}
              onChange={(e) => setNotificationBody(e.target.value)}
              onFocus={() => setActiveField("notificationBody")}
            />

            <div className="summernote-editor">
              <div className="form-group">
                <label>Email Subject</label>
                <input
                  ref={messageHeadingRef}
                  type="text"
                  value={messageHeading}
                  onChange={(e) => setMessageHeading(e.target.value)}
                  onFocus={() => setActiveField("messageHeading")}
                  required
                />
              </div>

              <div className="summernote-editor">
                <label>Email Body </label>
                <div ref={summernoteRef} style={{ minHeight: "300px" }} />
              </div>

              <div className="form-time-group">
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="when"
                      value="OnDATE"
                      checked={when === "OnDATE"}
                      onChange={(e) => setWhen(e.target.value)}
                    />
                    On Date
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="when"
                      value="DateBEFORE"
                      checked={when === "DateBEFORE"}
                      onChange={(e) => setWhen(e.target.value)}
                    />
                    Before
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="when"
                      value="DateAFTER"
                      checked={when === "DateAFTER"}
                      onChange={(e) => setWhen(e.target.value)}
                    />
                    After
                  </label>
                </div>
                {when !== "OnDATE" && (
                  <div className="form-group">
                    <label>Number of Days *</label>
                    <input
                      type="number"
                      value={days}
                      onChange={(e) => setDays(e.target.value)}
                      min="1"
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Time</label>

                  <input
                    type="time"
                    value={time}
                    onChange={handleTimeChange}
                    required
                  />
                  {delayInMs !== null && (
                    <p className="cron-preview">
                      <strong>Delay:</strong> {delayInMs} ms ({delayInMs / 1000}{" "}
                      seconds)
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="shared-placeholders-section">
            <h4>Placeholders</h4>
            <div className="placeholder-buttons-shared">
              {placeholders.map((ph) => (
                <button
                  key={ph.placeHolderId}
                  type="button"
                  onClick={() => insertPlaceholderInActiveField(ph.placeHolder)}
                  className="placeholder-btn"
                  // Remove the disabled prop
                >
                  {ph.placeHolder}
                </button>
              ))}
            </div>
            {/* Remove or update the hint message */}
            {!activeField && (
              <p className="placeholder-hint">
                Focus on any input field on the left to insert placeholders
                there
              </p>
            )}
          </div>
        </div>
        <div className="button-group">
          <button type="submit" className="submit-button">
            Schedule Cron Job
          </button>
        </div>
      </form>
    </div>
  );
};

export default CronJobForm;
